import { useEffect, useMemo, useState } from 'react';

export default function useAdminPagination(items, initialRowsPerPage = 5) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  const count = Array.isArray(items) ? items.length : 0;
  const totalPages = rowsPerPage > 0 ? Math.max(1, Math.ceil(count / rowsPerPage)) : 1;

  useEffect(() => {
    if (page > totalPages - 1) {
      setPage(Math.max(0, totalPages - 1));
    }
  }, [page, totalPages]);

  const paginatedItems = useMemo(() => {
    if (!Array.isArray(items)) {
      return [];
    }

    const start = page * rowsPerPage;
    return items.slice(start, start + rowsPerPage);
  }, [items, page, rowsPerPage]);

  const handlePageChange = (_event, nextPage) => {
    setPage(nextPage);
  };

  const handleRowsPerPageChange = (event) => {
    const nextRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(nextRowsPerPage);
    setPage(0);
  };

  return {
    page,
    rowsPerPage,
    count,
    paginatedItems,
    handlePageChange,
    handleRowsPerPageChange,
  };
}
